import axios from 'axios';
import { MessageBox, Message } from 'element-ui';
import store from '@/store';
import { getToken } from '@/utils/auth';

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['X-Token'] = getToken();
    }
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;

    // if the custom status is not 0, it is judged as an error.
    if (res.status !== 0 && res.status !== "success") {
      Message({
        message: res.message || res.messages || 'Error',
        type: 'error',
        duration: 5 * 1000
      });

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      }
      const error = new Error(res.message || res.messages || 'Error');
      error.response = res;
      return Promise.reject(error);
    } else {
      return res;
    }
  },
  error => {
    console.log('err' + error); // for debug
    if (error.message.indexOf('401') >= 0) {
      if (!store.getters.user) {
        // 如果没有登录并且遇到401错误，就不用弹窗提示
      }
      else {
        // to re-login
        MessageBox.confirm(
          '您已经退出登录，点击取消停留在当前页，或者重新登录',
          '提示',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload();
          });
        });
      }
    } else if (error.message.indexOf('timeout') >= 0) {
      Message({
        message: `服务器繁忙请稍后再试`,
        type: 'error',
        duration: 5 * 1000
      });
    } else {
      Message({
        message: `服务器繁忙请稍后再试`,
        type: 'error',
        duration: 5 * 1000
      });
    }
    return Promise.reject(error);
  }
);

export default service;
